import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../../../components/components"
import { ConfigContext } from "../../../contexts/CustomConfigContext"
import { ZahlungsbedingungenKomplexListView } from "./ZahlungsbedingungenKomplexListView"

export function ZahlungsbedingungenKomplexView() {
    const { t } = useTranslation()
    const config = useContext(ConfigContext)
    return (
        <>
            {!config?.skontoAlsText && (
                <div>
                    <Components.Collapsible title={t("rechnung.zahlungsdaten.zahlungsbedingungen.title")} collapsed={true}>
                        <ZahlungsbedingungenKomplexListView typ="SKONTO" />
                    </Components.Collapsible>
                </div>
            )}
        </>
    )
}
